module.exports = __webpack_public_path__ + "assets/img/next.d545a42a.png";